<template>
  <b-modal
    :id="`mc-modal-load-history-${data.index}`"
    ref="mc-modal-load-history"
    :title="`Perubahan Kuantitas Muatan #${data.do_number}`"
    class="mc-modal"
    size="lg"
    centered
  >
    <div class="card-body p-0">
      <McTable
        :withCard="false"
        searchable
        stickyHeader
        :hasCheckbox="false"
        :hasSelectAll="false"
        :fields="fields"
        :apiClient="apiClient"
        :hasViewManager="true"
        :isFirstRowClickable="false"
      >
        <template #customDisplayItems>
          <div class="flex">
            <McBadge
              :text="isPickUp ? 'Ambil' : 'Kirim'"
              :variant="isPickUp ? 'primary' : 'success'"
              size="medium"
              type="button"
            />
            <span class="text-muted text-sm">
              {{ 'Diubah oleh' }} <strong>{{ data.filter.updated_by }}</strong> {{ 'pada' }}
              <strong>{{ formatDateWithTz(data.filter.created_on) }}</strong>
            </span>
          </div>
        </template>
        <template #[`cell(product)`]="{ value }">
          <div
            v-b-tooltip.right="value?.name?.length > 60 ? value?.name : null"
            style="width: 150px"
            class="td__overflow-ellipsis-three-lines"
          >
            {{ value?.name }}
          </div>
          <div class="text-muted text-sm">
            {{ value?.type }}
          </div>
        </template>
      </McTable>
    </div>

    <template #modal-footer>
      <div class="d-flex mx-0">
        <McButton
          variant="primary"
          class="me-2"
          :text="$t('global.action.close')"
          @click="handleModalCancel"
        />
      </div>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import McTable from '@/components/McTable'
import McBadge from '@/components/McBadge'
import { formatDateWithTz } from '@/helpers/tzDate'
import * as historyApi from '@/services/rest-api/lib/delivery/history'
import filterMappings from '../lib/constants/filter-mappings'

import moment from 'moment'
moment.locale('id')

export default {
  components: {
    McButton,
    McTable,
    McBadge,
  },
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      isLoading: false,
      tooltips: {},
    }
  },
  computed: {
    isPickUp() {
      return this.data?.type?.toLowerCase() === 'ambil'
    },
    getEventFilterValue() {
      if (this.isPickUp) {
        return 'FleetPlanning.DeliveryLoadUpdatedPicked'
      } else {
        return 'FleetPlanning.DeliveryLoadUpdatedDropped'
      }
    },
    fields() {
      return [
        { label: 'Nama Produk', key: 'product', isSortable: false },
        { label: 'Kuantitas Lama', key: 'old_quantity', isSortable: false },
        { label: 'Kuantitas Baru', key: 'new_quantity', isSortable: false },
        {
          label: 'Alasan Perubahan',
          key: 'reason',
          isSortable: false,
          tdStyle: 'width: 150px',
          overFlowThreeLines: true,
          columnHasTooltip: true,
          columnTooltipLength: 60,
        },
      ]
    },
    apiClient() {
      const baseFilters = [
        {
          key: 'created_on',
          values: [this.data?.created_on],
        },
        {
          key: 'event',
          values: [this.getEventFilterValue],
        },
      ]

      const queryParamFilters = baseFilters.map(
        (filter) => filterMappings[filter.key]?.(filter.key, filter.values) ?? undefined
      )

      return {
        get: async (queryParam) => {
          const logResult = await historyApi.getLog(
            this.$route.params.id,
            queryParam,
            queryParamFilters
          )

          const keyMap = {
            product_name: 'product_name',
            product_type_name: 'product_type_name',
            uom: 'uom',
            old_qty: 'old_quantity',
            new_qty: 'new_quantity',
            reason: 'reason',
          }
          const remodeledLogData = logResult.data.paginated_result.map((log) => {
            const extractedData = {
              product_name: '',
              product_type_name: '',
              product: {
                name: '',
                type: '',
              },
              uom: '',
              old_quantity: '',
              new_quantity: '',
              reason: '',
            }

            log.details.forEach((item) => {
              if (keyMap[item.key]) {
                extractedData[keyMap[item.key]] = item.value
              }
            })
            extractedData.product = {
              name: extractedData.product_name,
              type: extractedData.product_type_name,
            }
            extractedData.old_quantity = `${extractedData.old_quantity} ${extractedData.uom}`
            extractedData.new_quantity = `${extractedData.new_quantity} ${extractedData.uom}`

            return extractedData
          })

          logResult.data.paginated_result = remodeledLogData

          return logResult
        },
      }
    },
  },
  methods: {
    formatDateWithTz,
    handleModalCancel() {
      this.$bvModal.hide(`mc-modal-load-history-${this.data.index}`)
      this.activeAttachmentIdx = null
    },
  },
}
</script>
